import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { requestProducts } from 'src/redux/products/thunks/requestProducts';
import { getProductsQueryStateFromSyncPayload } from './helpers/getProductsQueryStateFromSyncPayload';
import type {
  ProductsQueryState,
  SyncProductsQueryFromURLPayload,
} from './types/ProductsQueryState';

export type { ProductsQueryState, SyncProductsQueryFromURLPayload };
export const initialState: Readonly<ProductsQueryState> = {
  facets: [],
  isModalOpen: false,
  page: 1,
  sortOptions: [],
  taxonomyAttributeAliases: [],
};

export const { actions, reducer } = createSlice({
  name: 'productsQuery',
  initialState,
  reducers: {
    closeModal: (state) => {
      state.isModalOpen = false;
    },
    openModal: (state) => {
      state.isModalOpen = true;
    },
    changePage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    syncFromURLPayload: (state, action: PayloadAction<SyncProductsQueryFromURLPayload>) => {
      const { searchTerm } = action.payload;

      const nextState = getProductsQueryStateFromSyncPayload(state, action.payload);

      state.facets = nextState.facets;
      state.sortOptions = nextState.sortOptions;
      state.page = nextState.page;

      // Keep state JSON-serializable for SSR by removing absent optional fields.
      if (nextState.pageCategories === undefined) {
        delete state.pageCategories;
      } else {
        state.pageCategories = nextState.pageCategories;
      }

      if (searchTerm === undefined) {
        delete state.searchTerm;
      } else {
        state.searchTerm = searchTerm;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(requestProducts.fulfilled, (state, { payload }) => {
      if (payload.sortOptions) {
        state.sortOptions = payload.sortOptions;
      }

      if (payload.facets) {
        state.facets = payload.facets;
      }
    });
  },
});
